// Canonical lists used in filter dropdowns + lender form.
// Keep these in sync; add new values as your team needs them.

export const INDUSTRIES = [
  "Restaurant",
  "Retail",
  "Auto Repair",
  "Auto Sales",
  "Trucking",
  "Construction",
  "Healthcare",
  "Medical Practice",
  "Dental",
  "Veterinary",
  "Manufacturing",
  "Wholesale",
  "Professional Services",
  "Law Firm",
  "Accounting",
  "Marketing / Advertising",
  "Technology / Software",
  "Hospitality / Hotel",
  "Salon / Beauty",
  "Cleaning Services",
  "Landscaping",
  "Real Estate",
  "Real Estate Investor",
  "Property Management",
  "Plumbing",
  "HVAC",
  "Electrical",
  "Roofing",
  "General Contractor",
  "Food Service / Catering",
  "Grocery / Convenience",
  "Daycare",
  "Education",
  "Fitness / Gym",
  "Transportation / Logistics",
  "Towing",
  "Gas Station",
  "Liquor Store",
  "E-commerce",
  "Distribution",
  "Agriculture",
  "Cannabis",
  "Adult Entertainment",
  "Gambling",
  "Firearms",
  "Crypto / Web3",
  "Pawn Shop",
  "Used Car Dealer",
  "MCA / ISO Broker",
];

export const PRODUCT_TYPES = [
  "MCA",
  "Term Loan",
  "Line of Credit",
  "Equipment Finance",
  "SBA",
  "Bridge Loan",
  "Real Estate",
  "Construction Loan",
];

export const TIERS = [
  "Tier 1",
  "Tier 2A",
  "Tier 2B",
  "Tier 3A",
  "Tier 3B",
  "Tier 4",
  "Reverse",
  "Canada",
  "SBA / MAYA",
];

export const STATES = [
  "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA",
  "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD",
  "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ",
  "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC",
  "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY",
];

export const STATUSES = ["preferred", "active", "inactive", "test", "hidden"];
